import {
  DataVersion,
  IncidentDetail,
  IncidentProduct,
} from '@hakimo-ui/hakimo/types';
import { Button } from '@hakimo-ui/shared/ui-base';
import {
  AttachmentPreview,
  EmailComposeModal,
  EmailPayload,
} from './email-compose';
import { ReportLogoModal } from './ReportLogoModal';
import { formatInZone } from './util';
import { useIncidentReportActions } from './useIncidentReportActions';

interface Props {
  incident: IncidentDetail;
  product: IncidentProduct;
  dataVersion?: DataVersion;
  actions: ReturnType<typeof useIncidentReportActions>;
  showLogoModal: boolean;
  onCloseLogoModal: () => void;
  onSend: (payload: EmailPayload) => void;
}

export function IncidentDetailsModals({
  incident,
  product,
  dataVersion,
  actions,
  showLogoModal,
  onCloseLogoModal,
  onSend,
}: Props) {
  const {
    previewFile,
    reportFile,
    showPreview,
    setShowPreview,
    showEmailModal,
    setShowEmailModal,
    resetCompose,
    previewAttachment,
    composeEmail,
    clearGeneratedReport,
    sending,
  } = actions;

  return (
    <>
      {showPreview && previewFile && (
        <AttachmentPreview
          file={previewFile}
          onClose={() => setShowPreview(false)}
          actions={
            <>
              <Button variant="primary" onClick={composeEmail}>
                Compose Email
              </Button>
              <Button variant="outline" onClick={() => setShowPreview(false)}>
                Cancel
              </Button>
            </>
          }
        />
      )}

      <ReportLogoModal
        open={showLogoModal}
        onClose={onCloseLogoModal}
        alarmId={incident.alarm_id}
        product={product}
        dataVersion={dataVersion}
        currentLogoUrl={incident.report_logo_url}
        onLogoChanged={clearGeneratedReport}
      />

      <EmailComposeModal
        open={showEmailModal}
        onClose={() => setShowEmailModal(false)}
        onSend={onSend}
        isSending={sending}
        locationId={incident.location_id}
        site={incident.location_name}
        incidentStartTime={formatInZone(
          incident.incident_start_time_utc,
          incident.timezone
        )}
        description={incident.description}
        subjectId={incident.id}
        initialAttachment={previewFile ?? reportFile}
        onPreviewAttachment={previewAttachment}
        resetOnOpen={resetCompose}
      />
    </>
  );
}

export default IncidentDetailsModals;
